module.exports = __webpack_public_path__ + "img/cats-line.08216ca7.png";